<!-- results-table.component.html -->
<h1 mat-dialog-title><strong>Asociar</strong> {{LOCAL_DATA.nombreCompleto}} a estructura jerarquica</h1>
<div mat-dialog-content>
  <div class="content p-24" fxFlex="100" fxLayout="column">

    <div fxLayout="row" fxLayoutAlign="end end">
      <button mat-button (click)="openDialog()" mat-flat-button color="primary" class="add-row">Agregar Nodo/Estructura</button>
      </div>


      <table mat-table [dataSource]="LOCAL_DATA.estructuras" #mytable class="my-table mat-elevation-z8" fxFlex="100">


        <ng-container matColumnDef="estructura">
          <th mat-header-cell *matHeaderCellDef> Estructura </th>
          <td mat-cell *matCellDef="let element"> {{element.estructuraNombre}} </td>
        </ng-container>

        <ng-container matColumnDef="nombre">
          <th mat-header-cell *matHeaderCellDef> Nodo </th>
          <td mat-cell *matCellDef="let element"> {{element.nombre}} </td>
        </ng-container>

        <!-- Action Column -->
        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef> Acción </th>
          <td mat-cell *matCellDef="let element" class="action-link">
            <a (click)="delete(element)">Delete</a>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>

  </div>

</div>
<div mat-dialog-actions>
  <button mat-button (click)="closeDialog()" mat-flat-button color="warn">{{'Salir' | translate}}</button>
</div>
